import { Footer, Header, Helpers } from 'components'
import React, { useRef, useState, useLayoutEffect } from 'react'
import * as Styles from './Layout.module.css'

const Layout = ({ children, location, pageContext }) => {
  let websiteWrapper = useRef(null)
  let headerRef = useRef(null)
  const [navHeight, setNavHeight] = useState(0)

  /**
   * Gets page context from WordPress to check if the
   * page should hide any of the listed elements
   **/
  const { header, navigation, footer, buttons } = pageContext.pageSettings || {}

  /**
   * Gets the Header height, sets it using @function setNavHeight
   * to use it later to offset the layout
   **/
  useLayoutEffect(() => {
    setNavHeight(headerRef.current.offsetHeight)
    return
  }, [headerRef])

  return (
    <>
      <div ref={websiteWrapper}>
        <Helpers.ResponsiveGuides
          development={process.env.NODE_ENV === 'development'}
        />

        <div
          className={`${Styles.wrapper} ${
            location.pathname === '/product-updates/' ? 'bg-gray-50' : ''
          }`}
        >
          {(header || !pageContext?.pageSettings) && (
            <Header
              navHeight={navHeight}
              websiteWrapper={websiteWrapper}
              ref={headerRef}
              showNavigation={navigation || !pageContext?.pageSettings}
              showButtons={buttons || !pageContext?.pageSettings}
            />
          )}

          <div style={{ transform: `translateY(${navHeight}px)` }}>
            <main className={Styles.main}>{children}</main>
            <Footer />
            {/* <Footer minimal={!footer || !pageContext?.pageSettings} /> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout
